import { roles } from '@nxsys/store/constants';
import React from 'react';

const BulkUpdateListing = React.lazy(
  () => import('../../../modules/bulkUpdate/Listing'),
);

const BulkUpdateDetails = React.lazy(
  () => import('../../../modules/bulkUpdate/Details'),
);

const DownloadData = React.lazy(
  () => import('../../../modules/bulkUpdate/DownloadData'),
);

export const bulkUpdateConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/bulk-update',
    element: <BulkUpdateListing />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/bulk-update/:id',
    element: <BulkUpdateDetails />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/bulk-update/download-data',
    element: <DownloadData />,
  },
];
